export { ReactComponent as ElementImage } from './svgs/element-image.svg';
